import { endpoints } from "../../services/endpoint.ts/endpoint";
import { getData, postData, loginPostData } from "../api/action";

export const SET_SESSION = "SET_SESSION";
export const CLEAR_SESSION = "CLEAR_SESSION";

export const login = async (payload) => {
  const response = await loginPostData({ url: `${endpoints.LOGIN.url}` }, payload);
  return response;
};

export const logout = async () => {
  const response = await postData({ url: `${endpoints.LOGOUT.url}` });
  return response;
};

export const checkSession = async () => {
  const response = await getData({ url: `${endpoints.CHECK_SESSION.url}` });
  return response;
};

export const setSession = (session) => ({
  type: SET_SESSION,
  payload: session,
});

export const clearSession = () => ({
  type: CLEAR_SESSION,
});

// signup
export const signup = async (payload) => {
  const response = await postData({ url: `${endpoints.SIGNUP.url}` }, payload);
  // console.log("action signup response JSON: ", JSON.stringify(response, null, 2));
  return response;
};

export const findUsername = async (payload) => {
  // try {
    const response = await postData({ url: `${endpoints.FIND_USERNAME.url}` }, payload);
    // console.log("action findUsername response JSON: ", JSON.stringify(response, null, 2));
    return response;
  // } catch (error) {
  //   console.error("Error finding username:", error);
  //   throw error;
  // }
};

export const findPassword = async (payload) => {
  // try {
    const response = await postData({ url: `${endpoints.FIND_PASSWORD.url}` }, payload);
    return response;
  // } catch (error) {
  //   console.error("Error finding password:", error);
  //   throw error;
  // }
};
